/**
 * Formats bytes into a human-readable kilobyte string (e.g., "474 kB").
 *
 * @param {number} bytes - File size in bytes.
 * @returns {string} Formatted size string.
 */
export const formatFileSize = (bytes) => {
  if (!bytes || bytes === 0) return '0 kB';
  const kb = bytes / 1024;
  return `${kb.toFixed(0)} kB`;
};

/**
 * Extracts a displayable name from either a File object or a URL string.
 */
export const getFileName = (value) => {
  if (!value) return '';
  if (value instanceof File) return value.name;

  // If it's a URL string from the backend, extract the last part of the URL
  if (typeof value === 'string') {
    try {
      return value.split('/').pop() || 'uploaded-image';
    } catch {
      return 'uploaded-image';
    }
  }
  return 'uploaded-image';
};
